import React, { HTMLAttributes, useState } from 'react';

import Body from './Body';
import Layout from '../../../../../../components/TyAdvancedSearch/Components/Layout';

export interface Props extends HTMLAttributes<HTMLDivElement> {
  pageTitle: string
  setInitialValues: (values: object | undefined) => void
  initialValues: Record<string, object | undefined>
}

const TyAdvancedSearchMpsv: React.FC<Props> = ({
  pageTitle = 'Kdo hledá ten najde',
  setInitialValues,
  initialValues,
  ...props
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Layout
      {...props}
      pageTitle={pageTitle}
      showModal={showModal}
      setShowModal={setShowModal}
      initialValues={initialValues}
      setInitialValues={setInitialValues}
    >
      <Body />
    </Layout>
  );
};

export default TyAdvancedSearchMpsv;
